import React from "react";

export default function SideMenu({ clientData, onClose }) {
  return (
    <>
      <div className="overlay" onClick={onClose} />
      <div className="side-menu">
        <h2>Menu</h2>
        <ul>
          <li>
            <a
              href={clientData.ClientWebAddressURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {clientData.Description} Website
            </a>
          </li>
          <li>
            <a
              href="https://www.catss.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by Catss
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
